import React, { useState, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import "./Stores_page.css";
import Top_Header from "./Top_Header";
import Header from "./Header";
import About_p from "./About_p";
import Footer from "./Footer";
import ImageSlider from './ImageSlider'
import StickyComponent from "./Sticky_component";


// Main MultiLevelAccordion Component
const MultiLevelAccordion = ({ data }) => {
  return (
    <div className="accordion-container">
      {Object.keys(data).map((state) => (
        <StateAccordion key={state} name={state} areas={data[state]} />
      ))}
    </div>
  );
};

// State Accordion Component
const StateAccordion = ({ name, areas }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="accordion-item">
      <div className="accordion-header state" onClick={() => setIsOpen(!isOpen)}>
        {(name === 'Response')?'Stores':name}
        {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
      </div>
      {isOpen && (
        <div className="accordion-content">
          {Object.keys(areas).map((area) => (
            <AreaAccordion key={area} name={area} pincodes={areas[area]} />
          ))}
        </div>
      )}
    </div>
  );
};

// Area Accordion Component
const AreaAccordion = ({ name, pincodes }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="accordion-item area">
      <div className="accordion-header" onClick={() => setIsOpen(!isOpen)}>
      {(name === 'Response')?'Stores':name}
        {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </div>
      {isOpen && (
        <div className="accordion-content">
          {Object.keys(pincodes).map((pincode) => (
            <PincodeAccordion key={pincode} name={pincode} stores={pincodes[pincode]} />
          ))}
        </div>
      )}
    </div>
  );
};

// Pincode Accordion Component
const PincodeAccordion = ({ name, stores }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="accordion-item pincode">
      <div className="accordion-header" onClick={() => setIsOpen(!isOpen)}>
      {(name === 'Response')?'Stores':name}
        {isOpen ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
      </div>
      {isOpen && (
        <div className="accordion-content">
          {Object.keys(stores).map((store) => (
            <StoreAccordion key={store} name={store} details={stores[store]} />
          ))}
        </div>
      )}
    </div>
  );
};

// Store Accordion Component
const StoreAccordion = ({ name, details }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="accordion-item store">
      <div className="accordion-header" onClick={() => setIsOpen(!isOpen)}>
      {(name === 'Response')?'Stores':name}
        {isOpen ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
      </div>
      {isOpen && (
        <div className="accordion-content">
          <div className="store-image-container">
            <img src={details.url} alt={details.name} />
          </div>
          <p><strong>Name:</strong> {details.name}</p>
          <p><strong>Phone:</strong> {details.phone}</p>
          <p><strong>Address:</strong> {details.address}</p>
          <p>
            <a href={details.google_location} target="_blank" rel="noopener noreferrer">
              View on Google Maps
            </a>
          </p>
        </div>
      )}
    </div>
  );
};

// Main Component to Fetch Data
const Store = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  async function fetchData() {
    try {
      setLoading(true);
      const response = await fetch("https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/store-locator");
      const result = await response.json();
      return result;
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    // Fetch data dynamically
    const fetch = async () => {
      try {
        const result = await fetchData();
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, []);




  return (
    <>
      <Top_Header />
      <Header />
      <ImageSlider></ImageSlider>
      {
        loading ? (
          <div>Loading...</div>
        ) : (
          <MultiLevelAccordion data={data} />
        )
      }


      {
        <img src='https://khoslaslider.s3.ap-south-1.amazonaws.com/image/Kosla-Mascot.png' className='khosla_da_img' onClick={() => window.open(
          'https://api.whatsapp.com/send/?phone=919674425425&text&type=phone_number&app_absent=0',
          '_blank'
        )} />
      }
      <About_p />
      <Footer />
      <StickyComponent />
    </>
  )
};

export default Store;
